export const formatTotalFundingValue = (value: string): string => {
  let resultValue = '';

  const roundTenth = (val: number) => {
    let result = val;

    const integer = val.toString().substring(0, 1);
    const tenth = val.toString().substring(1, 2);

    if (+tenth !== 0) {
      result = +`${integer}.${tenth}`;
    } else result = +integer;

    return result;
  };

  if (typeof value === 'string') {
    switch (value.length) {
      case 18:
        resultValue = `${value.substring(0, 3)}Qd`;
        break;
      case 17:
        resultValue = `${value.substring(0, 2)}Qd`;
        break;
      case 16:
        resultValue = `${roundTenth(+value)}Qd`;
        break;
      case 15:
        resultValue = `${value.substring(0, 3)}T`;
        break;
      case 14:
        resultValue = `${value.substring(0, 2)}T`;
        break;
      case 13:
        resultValue = `${roundTenth(+value)}T`;
        break;
      case 12:
        resultValue = `${value.substring(0, 3)}B`;
        break;
      case 11:
        resultValue = `${value.substring(0, 2)}B`;
        break;
      case 10:
        resultValue = `${roundTenth(+value)}B`;
        break;
      case 9:
        resultValue = `${value.substring(0, 3)}M`;
        break;
      case 8:
        resultValue = `${value.substring(0, 2)}M`;
        break;
      case 7:
        resultValue = `${roundTenth(+value)}M`;
        break;
      case 6:
        resultValue = `${value.substring(0, 3)}K`;
        break;
      case 5:
        resultValue = `${value.substring(0, 2)}K`;
        break;
      case 4:
        resultValue = `${roundTenth(+value)}K`;
        break;
      default:
        resultValue = value;
    }
  }

  return resultValue;
};
